export enum QueryKey {
  getPartners = 'getPartners',
}
